import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-nps",
  "use": "icon-nps-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-nps\"><defs><style></style></defs><path d=\"M877.714 475.429v402.285h-768V146.286h585.143V73.143H73.143c-20.215 0-36.572 16.375-36.572 36.571v804.572c0 20.215 16.357 36.571 36.572 36.571h841.143c20.215 0 36.571-16.356 36.571-36.571V475.429h-73.143z\" /><path d=\"M1024 60.571c0-13.25-10.75-24-24-24-6.287 0-11.75 2.732-16.071 6.697L512.357 572.785 329.143 390.75 201.858 515.43h51.856l257.93 240.786 508.999-684.001c2-3.5 3.357-7.356 3.357-11.643z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol